import FormDialog from "../../components/dialog/form/FormDialog.vue";
import SelectField from "../../components/fields/selectField/SelectField.vue";
import TextField from "../../components/fields/textField/TextField.vue";
import { AtosBoletimService } from "../../services/AtosBoletimService";
import ConfirmDialog from "../../components/dialog/confirm/ConfirmDialog.vue"
import moment from "moment";
import EditarAto from "./editarAto/EditarAto.vue";
import EditarLegislacao from "./editarLegislacao/EditarLegislacao.vue";
import { numeroBmMixin } from "../../mixins/numeroBmMixin";


export default {
  name: "Boletim",

  components: {
    FormDialog,
    SelectField,
    TextField,
    ConfirmDialog,
    EditarAto,
    EditarLegislacao
  },
  mixins:[numeroBmMixin],
  data: () => ({
    perfilid: null,
    headers: [
      { text: "Nº BM", value: "numero", sortable: false },
      { text: "Militar", value: "nome", sortable: false },
      { text: "Tipo Ato", value: "tipo_ato", sortable: false },
      { text: "Data Geração Ato", value: "data_geracao", sortable: false },
      { text: "Ato Gerado", value: "ato_gerado", sortable: false },
      { text: "Excluir Ato", value: "actions", align: "center", sortable: false },
    ],
 
    data: [],
    loading:{
      table:false
    },
    idSelected: 0,

    page: 1,
    pageCount: 0,
    totalItems: 0,
    
    itemsPerPage: 10,

    usersSelecteds: [],

    nomeTexto:"Nome do Militar",
 
    options: {
      tiposAtos: [],
      atos:[],
    },

    confirmDialog:false,
    editarAto:false,
    editarLegislacao:false,

    filter: [],

  }),

  beforeMount(){
    this.getTiposAtos();
    this.getAtos();
    this.getDataTable();
    
    if(this.$store.state.user.Civil){
      this.nomeTexto = "Nome do Civil";

      this.headers =  [
        { text: "Nº BM", value: "numero", sortable: false },
        { text: "Civil", value: "nome", sortable: false },
        { text: "Tipo Ato", value: "tipo_ato", sortable: false },
        { text: "Data Geração Ato", value: "data_geracao", sortable: false },
        { text: "Ato Gerado", value: "ato_gerado", sortable: false },
        { text: "Excluir Ato", value: "actions", align: "center", sortable: false },
      ];
    }
    
  },
  

  watch: {
    page: function(val) {
      this.page = val;
      this.getDataTable();
      
    },
  },
  methods: {
    async getTiposAtos(){
      const response = await AtosBoletimService.listarTipos();

      this.options.tiposAtos = response.map((el) => {
        return {
          text: el.tipo_ato,
          value: el.id,
        };
      });

      this.options.tiposAtos?.unshift({ text: "Selecione", value: "" });

    },
    

    async getAtos(){
      const response = await AtosBoletimService.listarAtos();

      this.options.atos = response.map((el) => {
        return {
          text: el.genero_ato,
          value: el.id,
        };
      });

      this.options.atos?.unshift({ text: "Selecione", value: "" });

    },

    async getDataTable(){
      this.loading.table = true;
      const filter = this.prepareFormFilter()
      const response =  await AtosBoletimService.pesquisar(filter);
      this.data = response.data
      this.pageCount = response.last_page;
      this.totalItems = response.total;
      this.loading.table = false;
      this.$forceUpdate();
    },

    async pesquisarBoletimFiltros(){
      this.page=1;
      this.getDataTable();
    },

    async deletarAto(){
      const response = await AtosBoletimService.deletarAto(this.idSelected);
      if(response){
        this.getDataTable()
        this.confirmDialog = false;
      }
      return;
    },
    async downloadAto(idAto){
      return await AtosBoletimService.downloadAto(idAto);
    },
    prepareFormFilter() {
      const filter = new FormData();

      filter.append("page", this.page);


      if (this.filter.numeroBM) {
        const numeroBM = this.filter.numeroBM.replace(".", "");
        const [numero, digitoVerificador] = numeroBM.split("-");
        filter.append("numero", this.removerZero(numero));
        if (digitoVerificador != undefined) filter.append("digito_verificador", digitoVerificador);
      }

      this.filter.nome ? filter.append("nome", this.filter.nome) : null;
      this.filter.atos ? filter.append("ato", this.filter.atos) : null;
      this.filter.tipoAto ? filter.append("id_tipo", this.filter.tipoAto) : null;
      this.filter.data ? filter.append("data",moment(this.filter.data).format("YYYY-MM-DD")): null;
      return filter;
    },

    mostrarDeletarAto(id){
      this.idSelected = id;
      this.confirmDialog = true;
    },

  mostrarEditarAto(id){
      this.idSelected = id;
      this.editarAto = true;
    },

    closeEditarAto(){
      this.editarAto = false;
      this.getDataTable();
    }
  },
};